import React, { useEffect } from "react";
import './error.css';

const Error = () => {
      useEffect(() => {
        if (window && document) {
            var countdown = 20;
            var redirectTimer = setInterval(function() {
              countdown--;
              document.getElementById("countdown").innerText = countdown;
              if (countdown <= 0) {
                clearInterval(redirectTimer);
                window.location.href = "https://www.triniteq.com"; // Redirect to Triniteq.com
              }
            }, 1000);
        }
      }, [])
    
  return ( 
        <div className="container errorHomePage">
            <div className="logo">
            <img src="https://7875214.fs1.hubspotusercontent-na1.net/hub/7875214/hubfs/triniteq_logo-WHITE_2col-filled-CMYK%20-%20transparent%20background%20white%20teq.png?width=124&height=55&name=triniteq_logo-WHITE_2col-filled-CMYK%20-%20transparent%20background%20white%20teq.png" alt="Triniteq Logo"/>
            </div>
            <h1>Kiosk Access Error</h1>
            <p>The URL you entered is invalid for kiosk access.</p>
            <p>Please contact Triniteq support at <a href="mailto:support@triniteq.com">support@triniteq.com</a> if you need to be supplied the URL again.</p>
            <div className="contact">
            <p>Alternatively, you can reach us at <a href="tel:1300784276">1300 784 276</a>.</p>
            </div>
            <div id="redirectMessage">
            <p>You will be redirected to the Triniteq.com website in <span id="countdown">20</span> seconds.</p>
            </div>
        </div>
    );
};

export default Error;
